<div class="multisearch-box">
  <div class="control">
    <label for="multi-search-input-{{ uniqueId }}"
      >{{ label }}@if (required) {<span
        class="required-indicator has-text-danger"
        >*required</span
      >}</label
    >
    @if (helpText) {
    <p class="help mb-1">{{ helpText }}</p>
    } @if (htmlHelpText) {
    <div class="content help mb-1" [innerHTML]="htmlHelpText"></div>
    } @if (selectedSearchResults.length) {
    <div class="field is-grouped is-grouped-multiline">
      @for (selectedSearchResult of selectedSearchResults; track
      selectedSearchResult) {
      <div class="control">
        <div class="tags has-addons">
          <span class="tag is-link"
            ><i
              class="icon pr-5 pl-3 {{
                getResourceIcon(selectedSearchResult.resourceName)
              }}"
            ></i
            >{{ selectedSearchResult.label }}</span
          >
          @if (!readonly) {
          <a
            class="tag is-delete has-background-link-light"
            (click)="toggleItem(selectedSearchResult)"
          ></a>
          }
        </div>
      </div>
      }
    </div>
    }
    <div class="is-flex is is-align-items-flex-start">
      <div class="is-fullwidth">
        <div class="multisearch-input-field">
          <input
            id="multi-search-input-{{ uniqueId }}"
            type="text"
            class="input"
            (keyup)="onSearchInputKeyup($event)"
            [placeholder]="
              selectedSearchResults.length ? '' : placeholder || label + '...'
            "
            (focus)="showList = true; focusedItemIndex = 0"
            [disabled]="
              readonly ||
              (maxSelectedItems &&
                selectedSearchResults.length >= maxSelectedItems)
            "
            [class.is-danger]="
              showErrors && required && !selectedSearchResults.length
            "
            autocomplete="off"
            #searchInput
          />

          <!-- Filters -->
          @if (filter) {
          <div class="filter-section">
            <span class="content is-small mr-2"
              >Filter by {{ filter.nameSingular | lowercase }}:</span
            >

            @for (filterItem of filterItems; track filterItem) {
            <span
              class="tag pointer mr-2 mb-2 is-rounded is-outlined"
              [class.is-link]="filterItem.selected"
              (click)="toggleFilterItem(filterItem)"
              >{{ filterItem.label }}</span
            >&nbsp; }
          </div>
          } @if (showList && suggestedSearchResults.length) {
          <ul class="box list">
            @if (activeFilterItem && !isAllSelected()) {
            <li class="pointer" (click)="selectAll()">
              Select all results from&nbsp;
              <strong>{{ activeFilterItem.label }}</strong>
            </li>
            } @if (activeFilterItem && isAllSelected()) {
            <li class="pointer" (click)="unselectAll()">
              Unselect all results from&nbsp;
              <strong>{{ activeFilterItem.label }}</strong>
            </li>
            } @for (searchResult of suggestedSearchResults; track searchResult;
            let i = $index) {
            <li
              class="pointer"
              [class.is-active]="isSelected(searchResult)"
              [class.is-focused]="focusedItemIndex === i"
              [class.pointer]="searchResult.resourceName !== 'groupHeader'"
              [class.group-header]="searchResult.resourceName === 'groupHeader'"
              (click)="toggleItem(searchResult)"
            >
              <!-- Icon-->
              <i
                class="icon is-size-5 {{
                  getResourceIcon(searchResult.resourceName)
                }}"
              ></i>
              <span innerHTML="{{ searchResult.label }}"></span>
            </li>
            }
          </ul>
          }
        </div>
      </div>
      @if (showCreateButton && !isReadOnlyTaxonomy(resources[0].slug)) {
      <a (click)="showCreateModal = true" class="button is-link is-light ml-2">
        <i class="icon icon-plus is-size-4"></i>
      </a>
      }
    </div>
  </div>
</div>

@if (showCreateModal) {
<div class="modal is-active">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head pb-0">
      <p class="modal-card-title">Add a {{ resources[0].nameSingular }}</p>
      <a
        class="is-flex is-align-item-center has-text-dark"
        aria-label="close"
        (click)="showCreateModal = false"
      >
        <i class="icon icon-x is-size-2"></i>
      </a>
    </header>
    <section class="modal-card-body is-size-5">
      <div class="columns">
        <div class="column">
          <div [formGroup]="createForm">
            <div class="control">
              <label for="new-item"
                >Name@if (required) {<span
                  class="required-indicator has-text-danger"
                  >*required</span
                >}</label
              >
              <input
                type="text"
                class="input form-control"
                [class.is-danger]="showErrors && createForm.invalid"
                (keypress)="onCreateInputKeyUp($event)"
                [placeholder]="'Name...'"
                formControlName="name"
                id="new-item"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer
      class="modal-card-foot pt-0 is-flex is-justify-content-space-between"
    >
      <button class="button is-white" (click)="showCreateModal = false">
        Cancel
      </button>
      <button class="button is-link" (click)="submitCreate()">Save</button>
    </footer>
  </div>
</div>
}
